<template>
  <div>
    <div v-if="!cartGroups.length">
      <div class="section">
        <p class="has-text-centered is-size-3">Košík je prázdný</p>
        <div class="buttons mt-5 is-centered">
          <a :href="ordersIndexUrl" class="button is-white">
            <span class="icon icon--cart"><i class="fas fa-shopping-cart"></i></span>
            <span>Přidat položky</span>
          </a>
        </div>
      </div>
    </div>
    <div class="columns is-multiline is-gapless is-centered" v-else>
      <div class="column is-12-mobile is-12-tablet is-6-desktop is-6-widescreen">
        <div class="section">
          <h2 class="title is-size-4 pl-2" :class="'has-text' + secondaryColor">
            <span class="pl-2">Obsah košíku</span>
          </h2>
          <div v-for="cartGroup in cartGroups" :key="cartGroup.key" class="pb-3">
            <h3 class="title is-size-6 has-text-grey has-text-weight-normal pl-2">
              <span class="pl-2">{{ cartGroup.name }}</span>
            </h3>
            <div v-for="cartLine in cartGroup.cart_lines" :key="cartLine.key" class="mb-5">
              <LunchMeal
                  v-if="cartGroup.type === 'lunch_day'"
                  :color="secondaryColor"
                  :always-visible="false"
                  :lunch-meal-props="cartLine.lunch_meal"
                  :lunch-day-props="cartLine.lunch_day"
                  :sold-out-props="cartLine.sold_out"
              ></LunchMeal>
              <OfferMeal
                  v-else-if="cartGroup.type === 'offer_category'"
                  :color="secondaryColor"
                  :always-visible="false"
                  :offer-meal-props="cartLine.offer_meal"
                  :sold-out-props="cartLine.sold_out"
              ></OfferMeal>
            </div>
          </div>

          <div class="buttons mt-3 is-centered">
            <a :href="ordersIndexUrl" class="button is-white">
              <span class="icon icon--cart"><i class="fas fa-shopping-cart"></i></span>
              <span>{{ $t('orders.actions.addMoreItems') }}</span>
            </a>
          </div>
        </div>
      </div>
      <OrderInfo
          :secondary-color="secondaryColor"
          :delivery-types="deliveryTypes"
          :payment-types="paymentTypes"
          :send-url="sendUrl"
          :csrf-token="csrfToken"
      ></OrderInfo>
    </div>
  </div>
</template>

<script>
import cartGetters from "../../../store/web/cart/getter-types";
import OrderInfo from "./OrderInfo.vue";
import LunchMeal from "./LunchMeal.vue";
import OfferMeal from "./OfferMeal.vue";

export default {
  components: {OfferMeal, LunchMeal, OrderInfo},
  props: {
    // cartUrl: String,
    secondaryColor: String,
    deliveryTypes: Array,
    paymentTypes: Array,
    sendUrl: String,
    ordersIndexUrl: String,
    csrfToken: String,
  },
  computed: {
    cartGroups() {
      return this.$store.getters['cart/' + cartGetters.GET_CART_GROUPS];
    },
  }
}
</script>
